






























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { Settings, DateTime } from 'luxon'

@Component({components: {Datetime}})
export default class DatePickerWings extends Vue {
  @Prop() value!: string;
  @Prop() minDatetime!: string;
  @Prop({ default: true }) isSetMinDatetime!: boolean;
  @Prop({ default: 'datetime' }) readonly type!: string;
  @Prop({ default: () => {}}) readonly errorsList!: any;
  @Prop({ default: false }) readonly disableCloseButton!: boolean;
  @Prop({ default: null }) format!: string;

  created(){
    Settings.defaultLocale = this.$i18n.locale;
  }

  get valueSelf():string{
    let min = this.minDatetime;
    if (min && this.isSetMinDatetime){
      let minDate = DateTime.fromISO(min).set({millisecond:0});
      let value = DateTime.fromISO(this.value).set({millisecond:0});
      if (value < minDate) {
        this.$emit('input',minDate.plus({hour:1}).toISO({
          includeOffset: false,
          suppressMilliseconds: true
        }))
      }
    }
    if (this.format && this.value) return DateTime.fromFormat(this.value, this.format).toISO()

    return this.value
  }

  set valueSelf(value:string){
    if (this.type == 'datetime' && value){
      value = DateTime.fromISO(value).set({millisecond:0}).toISO({
        includeOffset: false,
        suppressMilliseconds: true
      }) ?? ''
    } else if (this.type == 'time' && value){
      value = DateTime.fromISO(value).set({millisecond:0}).toISOTime({
        includeOffset: false,
        suppressSeconds: true,
        suppressMilliseconds: true,
      }) ?? ''
    } else if (this.type == 'date' && value){
      if (this.format) value = DateTime.fromISO(value).toFormat(this.format) ?? ''
      else value = DateTime.fromISO(value).set({millisecond:0}).toFormat('yyyy-LL-dd') ?? ''
    }
    if (value){
      this.$emit('input',value)
    }
  }

  // log(str: string) {
  //   console.log(this.$options.name, ' LOG:\t', this.$el?.id, ' - ', str)
  // }

  // @Watch('value', {immediate: true})
  // onValueChange(newv: any, oldv: any) {
  //   this.log('watch-value(new, old)=' + `(${newv}, ${oldv})`)
  // }
}
